/**
 * One builder edits events and courses: /builder/<id>. Views share names
 * (e.g. 'moz' for the БПР tab).
 */
export function builderPath(
  contentId: string,
  view?: string,
  extra?: Record<string, string>
): string {
  const params = new URLSearchParams();
  if (view) params.set('view', view);
  for (const [k, v] of Object.entries(extra ?? {})) params.set(k, v);
  const qs = params.toString();
  return `/builder/${contentId}${qs ? `?${qs}` : ''}`;
}

/** Opens the builder for a new item of the given type. */
export function newBuilderPath(type: 'event' | 'course'): string {
  return `/builder/new?type=${type}`;
}
